var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('transition',{attrs:{"enter-active-class":"animated fadeIn faster","leave-active-class":"animated fadeOut faster","mode":"out-in"}},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }